import React, { useState } from "react";
import close from "../../assets/images/close.svg";
import { Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";

const WorkFlowLogFilterPopup = ({
  handleshowPopup,
  handleSubmit,
  FilterData,
  setShowMessage,
}) => {
  const today = new Date();
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(today.getDate() - 7);
  // const formattedStartDate = moment()
  //   .clone()
  //   .subtract(6, "days")
  //   .toISOString()
  //   .split("T")[0];
  // const formattedEndDate = today.toISOString().split("T")[0];

  let intialObj = {
    startdate: FilterData?.startdate ? FilterData?.startdate : sevenDaysAgo,
    enddate: FilterData?.enddate
      ? FilterData?.enddate
      : today.setDate(today.getDate() - 1),
    SearchTerm: FilterData?.SearchTerm ? FilterData?.SearchTerm : "",
    status: FilterData?.status ? FilterData?.status : "",
  };
  const [Input, setInput] = useState(intialObj);

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setInput({
      ...Input,
      startdate: start ? start : "",
      enddate: end ? end : "",
    });
  };
  const formatDate = (date) => {
    if (date) {
      const yyyy = date?.getFullYear();
      const mm = String(date?.getMonth() + 1)?.padStart(2, "0");
      const dd = String(date?.getDate())?.padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    }
  };

  const handlePresetSelection = (preset) => {
    const end = new Date();
    const endNew = new Date();

    end.setDate(end.getDate() - 1); // yesterday

    let start = new Date(end); // base everything off "yesterday"

    switch (preset) {
      case "Last Seven Days":
        start.setDate(end.getDate() - 6); // 7-day range including yesterday
        break;
      case "1 Month":
        start.setMonth(end.getMonth() - 1);
        break;
      case "3 Month":
        start.setMonth(end.getMonth() - 3);
        break;
      case "6 Month":
        start.setMonth(end.getMonth() - 6);
        break;
      case "1 Year":
        start.setFullYear(end.getFullYear() - 1);
        break;
      case "2 Year":
        start.setFullYear(end.getFullYear() - 2);
        break;
      default:
        start = end;
    }

    start.setDate(start.getDate() + 1);

    setInput({
      ...Input,
      startdate: start,
      enddate: preset === "Last Seven Days" ? endNew : end,
    });
  };

  const isPresetActive = (preset) => {
    const end = new Date();
    const endNew = new Date();
    end.setDate(end.getDate() - 1); // yesterday

    let start = new Date(end); // base everything off "yesterday"

    switch (preset) {
      case "Last Seven Days":
        start.setDate(end.getDate() - 6);
        break;
      case "1 Month":
        start.setMonth(end.getMonth() - 1);
        break;
      case "3 Month":
        start.setMonth(end.getMonth() - 3);
        break;
      case "6 Month":
        start.setMonth(end.getMonth() - 6);
        break;
      case "1 Year":
        start.setFullYear(end.getFullYear() - 1);
        break;
      case "2 Year":
        start.setFullYear(end.getFullYear() - 2);
        break;
      default:
        start = end;
    }
    start.setDate(start.getDate() + 1);
    return (
      formatDate(Input.startdate) === formatDate(start) &&
      formatDate(Input.enddate) ===
        formatDate(preset === "Last Seven Days" ? endNew : end)
    );
  };
  const FnForSetStatus = (selectedStatus) => {
    setInput({
      ...Input,
      status: selectedStatus,
    });
  };
  const handleReset = () => {
    setShowMessage(false);
    // Reset the state to initial values
    const resetValues = {
      startdate: sevenDaysAgo,
      enddate: new Date(today.setDate(today.getDate() - 1)),
      SearchTerm: "",
      status: "",
    };

    setInput(resetValues);

    // Send clear values to parent
    handleSubmit(resetValues);
  };

  return (
    <div className="schedular-popup header-border filter-popup">
      <div className="popup-title">
        <h2>Filter</h2>
        <img
          src={close}
          alt="close"
          className="cursor-pointer"
          id="log-filter"
          onClick={(e) => {
            handleshowPopup(e);
          }}
        />
      </div>
      <div className="popup-body logfilterpopup">
        <Row>
          <div className="single-filter">
            <div className="d-flex align-items-center justify-content-between common-tab-titles">
              <h5 className="">Status</h5>
            </div>
            <div className="all-grey-blue-badges">
              {["Completed", "Inprogress", "Failed", "Partial Success"].map(
                (status) => (
                  <span
                    key={status}
                    className={
                      Input.status === status
                        ? "grey-badge active"
                        : "grey-badge"
                    }
                    onClick={() => FnForSetStatus(status)}
                  >
                    {status}
                  </span>
                )
              )}
            </div>
          </div>
          <div className="single-filter">
            <div className="d-flex align-items-center justify-content-between common-tab-titles">
              <h5 className="">Select Date</h5>
            </div>
            <div className="all-grey-blue-badges">
              {[
                "Last Seven Days",
                "1 Month",
                "3 Month",
                "6 Month",
                "1 Year",
                "2 Year",
              ].map((preset) => (
                <span
                  key={preset}
                  className={
                    isPresetActive(preset) ? "grey-badge active" : "grey-badge"
                  }
                  onClick={() => handlePresetSelection(preset)}
                >
                  {preset}
                </span>
              ))}
            </div>
          </div>
          <Col xl={12}>
            {/* <Form.Label className="common-label">Select Date</Form.Label> */}
            <div>
              <DatePicker
                showYearDropdown
                showMonthDropdown
                selected={Input.startdate ? new Date(Input.startdate) : null}
                maxDate={new Date()}
                onChange={handleDateChange}
                startDate={Input.startdate ? new Date(Input.startdate) : null}
                endDate={Input.enddate ? new Date(Input.enddate) : null}
                selectsRange
                placeholderText="Select Date"
                isClearable
                dateFormat="MM/dd/yyyy"
              />
            </div>
          </Col>
        </Row>
      </div>

      {/* Footer */}
      <div className="popup-footer">
        <button className="grey-btn" onClick={() => handleReset()}>
          Reset
        </button>
        <button
          className="blue-btn"
          onClick={async (e) => {
            setShowMessage(true);
            handleSubmit(Input);
            handleshowPopup(e);
          }}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default WorkFlowLogFilterPopup;
